import { promiseState } from "../../helper"
import { resource } from "../actions/types"

const { pendingState, fulfilledState, rejectedState } = promiseState

const initialState = {
	isLoading: false,
	message: null,
	errors: [],
	data: [],
	page: {
		totalPage: 0,
		currentPage: 1,
		totalData: 0,
	},
	detail: {},
}

const resourceReducer = (state = initialState, action) => {
	switch (action.type) {
		case pendingState(resource.GET_RESOURCES): {
			return Object.assign({}, state, {
				isLoading: true,
			})
		}

		case rejectedState(resource.GET_RESOURCES): {
			return Object.assign({}, state, {
				isLoading: false,
			})
		}

		case fulfilledState(resource.GET_RESOURCES): {
			return Object.assign({}, state, {
				isLoading: false,
				data: action.payload.data.data,
				page: {
					totalPage: action.payload.data.page.totalPage,
					currentPage: action.payload.data.page.currentPage,
					totalData: action.payload.data.page.totalData,
				},
			})
		}

		case pendingState(resource.GET_RESOURCE_DETAIL): {
			return Object.assign({}, state, {
				isLoading: true,
			})
		}

		case rejectedState(resource.GET_RESOURCE_DETAIL): {
			return Object.assign({}, state, {
				isLoading: false,
			})
		}

		case fulfilledState(resource.GET_RESOURCE_DETAIL): {
			return Object.assign({}, state, {
				isLoading: false,
				detail: action.payload.data.data,
			})
		}

		default:
			return state
	}
}

export default resourceReducer
